var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"mb-1"},[_vm._v("Suas empresas")]),_c('b-table',{staticClass:"border",attrs:{"items":_vm.companies,"fields":_vm.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }